import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { SolicitudPersonaContactoEmpresaDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class SolicitudPersonaContactoEmpresaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getSolicitudPersonaContactoEmpresaService(): Observable<BodyListResponse<SolicitudPersonaContactoEmpresaDTO>> {
    return this.http.get<BodyListResponse<SolicitudPersonaContactoEmpresaDTO>>(API_URL + '/api/v1/solicitudPersonaContactoEmpresa/todos');
  }

  guardarSolicitudPersonaContactoEmpresaService(solicitudPersonaContactoEmpresaDTO: SolicitudPersonaContactoEmpresaDTO): Observable<BodyResponse<SolicitudPersonaContactoEmpresaDTO>> {
    return this.http.post<BodyResponse<SolicitudPersonaContactoEmpresaDTO>>(API_URL + '/api/v1/solicitudPersonaContactoEmpresa', solicitudPersonaContactoEmpresaDTO);
  }

  getSolicitudPersonaContactoEmpresaPorCodigoService(codigo: string): Observable<BodyResponse<SolicitudPersonaContactoEmpresaDTO>> {
    return this.http.get<BodyResponse<SolicitudPersonaContactoEmpresaDTO>>(API_URL + '/api/v1/solicitudPersonaContactoEmpresa/' + codigo);
  }

  getSolicitudPersonaContactoEmpresaPorSolicitudService(codigo: string): Observable<BodyListResponse<SolicitudPersonaContactoEmpresaDTO>> {
    return this.http.get<BodyListResponse<SolicitudPersonaContactoEmpresaDTO>>(API_URL + '/api/v1/solicitudPersonaContactoEmpresa/solicitud/' + codigo);
  }
}
